import axios from 'axios';
import errorManager from '@/rollbar.js';

const notificationInizializer = () => {
  const CHECK_INTERVAL_TIME = 5 * 1000; // when to check
  const TIMED_OUT_LIMIT = 30 * 1000; // manually check workers
  let activeNotifications = [];

  const deleteNotification = (jobId) => {
    if (!jobId) return;
    activeNotifications = activeNotifications.filter((n) => n.job_id != jobId);
  };

  const isTimedOut = (notification) => {
    const inProgress = notification.progress != 100 && notification.progress !== null && notification.progress !== undefined;
    const timedOutLimit = window.config.notificationService.enableNotifications ? TIMED_OUT_LIMIT : 0;
    return inProgress && moment() - notification.updated_at > timedOutLimit;
  };

  const pollNotifications = (notifications) => {
    const job_ids = notifications.map((n) => n.job_id);
    if (job_ids.length == 0) return;
    axios.get(`/asynch/job_statuses?job_ids=${job_ids.join(',')}`).then((res) => {
      const jobStatuses = res.data;

      for (let iJobId = 0; iJobId < jobStatuses.length; iJobId++) {
        const jobId = job_ids[iJobId];
        switch (jobStatuses[iJobId].job_status) {
          case null:
            deleteNotification(jobId);
            break;
          case 'complete': {
            const originalNotification = activeNotifications.find((n) => n.job_id == jobId);
            if (originalNotification && originalNotification.progress != 100) {
              const completedNotification = {
                ...originalNotification,
                job_id: jobId,
                message: i18nJS.report_generato_success,
                message_data: JSON.stringify({
                  reportName: 'Report',
                  fileUrl: jobStatuses[iJobId].s3_url,
                }),
                progress: 100,
                updated_at: moment(),
                tags: 'epersonam-job,epersonam-print,epersonam',
              };
              deleteNotification(jobId);
              eventBus.$emit('addUINotification', completedNotification); // socketless volatile notification
            }
            break;
          }
          case 'failed': {
            const failedNotification = {
              ...activeNotifications.find((n) => n.job_id == jobId),
              job_id: jobId,
              message: i18nJS.report_generato_failed,
              message_data: JSON.stringify({}),
              message_status: 500,
              progress: 100,
              updated_at: moment(),
              tags: 'epersonam-job,epersonam-print,epersonam',
            };
            deleteNotification(jobId);
            eventBus.$emit('addUINotification', failedNotification); // socketless volatile notification
            break;
          }
          default:
            break;
        }
      }
    });
  };

  $(document).ready(() => {
    const checkInterval = window.config.notificationService.enableNotifications ? CHECK_INTERVAL_TIME : 3000;

    setInterval(() => {
      const timedOutNotifs = activeNotifications.filter((n) => isTimedOut(n));
      pollNotifications(timedOutNotifs);
    }, checkInterval);
  });

  const enqueueJob = (notification) => {
    if (!notification.job_id) return;
    notification.created_at = moment.utc(notification.created_at);
    notification.updated_at = moment.utc(notification.updated_at);

    deleteNotification(notification.job_id);
    activeNotifications.push(notification);
  };

  eventBus.$on('generateReport', (notification) => {
    notification = notification || {};
    notification.autoDownload = true;
    if (!notification.notification_id) {
      const now = new Date();
      notification = {
        ...notification,
        service_name: 'epersonam',
        message: i18nJS.printing,
        progress: -1,
        created_at: now,
        updated_at: now,
      };
    }
    eventBus.$emit('addUINotification', notification); // socketless volatile notification
    enqueueJob(notification);
  });

  eventBus.$on('addNotification', (notification) => {
    enqueueJob(notification);
  });

  eventBus.$on('deleteNotification', (notification) => deleteNotification(notification.job_id));
};

const init = () => {
  try {
    notificationInizializer();
  } catch (e) {
    errorManager(e);
  }
};

window.JobSupervisor = {
  init: init,
};
